import React, { Component, Fragment } from 'react';
import SectionHeading from '../section-heading/SectionHeading';
import Rule from '../rule/Rule';
import { connect } from 'react-redux';
import { updateRuleStatus } from '../redux/actions';
import { getSelectedJurisdictionCode } from '../../../../jurisdiction/redux/selectors';

class TurnedOffRules extends Component {
    enableRule = ruleId => {
        const { enableRule, jurisdictionCode } = this.props;

        jurisdictionCode && enableRule && enableRule(ruleId, jurisdictionCode);
    };

    renderRules() {
        const { rules } = this.props;

        return rules && rules.length ? (
            <Fragment>
                {rules.map(rule => (
                    <Rule
                        key={rule.id}
                        rule={rule}
                        active={false}
                        readOnly={this.props.readOnly}
                        enableRule={this.enableRule}
                    />
                ))}
            </Fragment>
        ) : (
            <span className="rules-empty">
                When you turn off some of the already activated rules, they’ll
                move here.
            </span>
        );
    }

    render() {
        return (
            <Fragment>
                <SectionHeading
                    heading="Inactive Rules"
                    subHeading="Rules that you created and are turned off."
                />
                {this.renderRules()}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { disabled } = state.rules.data;
    const jurisdictionCode = getSelectedJurisdictionCode(state);

    return {
        rules: disabled,
        jurisdictionCode
    };
};

const mapDispatchToProps = dispatch => ({
    enableRule: (ruleId, jurisdictionCode) =>
        dispatch(updateRuleStatus({ ruleId, enabled: true, jurisdictionCode }))
});

export default connect(mapStateToProps, mapDispatchToProps)(TurnedOffRules);

// Example data.
// const disabledRules = [
//     {
//         id: 1,
//         rule: 'User crossed [$${value}] in earnings.',
//         ruleVariables: {value: '[$]10000'}
//     }
// ];
